import { CommonCodeRequirementKey } from 'src/store/useCommonCodeStore';
import { CommonCodeRequirement } from './CommonCodeValidateContext';

export const COMMON_CODE_REQUIREMENT_CONFIG: Partial<Record<CommonCodeRequirementKey, { key: CommonCodeRequirementKey; message: string }>> = {
	compCdList: {
		key: 'compCdList',
		message: '사업장 정보가 등록되지 않았습니다. 사업장 정보를 등록해주세요.',
	},
	ordTypeList: {
		key: 'ordTypeList',
		message: '지시구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	jobTeamList: {
		key: 'jobTeamList',
		message: '작업팀 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	workPlaceList: {
		key: 'workPlaceList',
		message: '공정 정보가 등록되지 않았습니다. 공정 정보를 등록해주세요.',
	},
	workProcessList: {
		key: 'workProcessList',
		message: '공정유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	unitList: {
		key: 'unitList',
		message: '단위 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	yesNoList: {
		key: 'yesNoList',
		message: '예/아니오 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	employeeCdList: {
		key: 'employeeCdList',
		message: '작업자 코드가 등록되지 않았습니다. 사용자 정보를 등록해주세요.',
	},
	faultyValueList: {
		key: 'faultyValueList',
		message: '불량유형 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	itemStatusList: {
		key: 'itemStatusList',
		message: '품목상태 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	moneyCdList: {
		key: 'moneyCdList',
		message: '화폐단위 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	vatTypeList: {
		key: 'vatTypeList',
		message: '부가세구분 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	wmsCdList: {
		key: 'wmsCdList',
		message: '물류센터 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
	warehouseCdList: {
		key: 'warehouseCdList',
		message: '창고 정보가 등록되지 않았습니다. 창고 정보를 등록해주세요.',
	},
	downtimeValueList: {
		key: 'downtimeValueList',
		message: '비가동사유 코드가 등록되지 않았습니다. 공통코드를 등록해주세요.',
	},
};

/** KSK2010 메인 그리드 신규 행 기본값 */
export const KSK2010_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'ordTypeList',
	'workPlaceList',
	'jobTeamList',
];

/** KSK2010 검색 영역 */
export const KSK2010_R01_SEARCH_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'workPlaceList',
	'jobTeamList',
	'yesNoList',
];

export const KSK2010_R01_ORDER_WORKPLACE_MESSAGE =
	'지시 가능한 작업공정(useYn=Y, orderYn=Y)이 등록되지 않았습니다. 공정 정보를 등록해주세요.';

/** KSK2011 메인 그리드 신규 행 기본값 */
export const KSK2011_R01_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'ordTypeList',
	'workPlaceList',
	'jobTeamList',
];

/** KSK2011 검색 영역 */
export const KSK2011_R01_SEARCH_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'workPlaceList',
	'jobTeamList',
	'yesNoList',
];

export const KSK2011_R01_ORDER_WORKPLACE_MESSAGE =
	'지시 가능한 작업공정(useYn=Y, orderYn=Y)이 등록되지 않았습니다. 공정 정보를 등록해주세요.';

/** KSK1070 헤더(입고 Info) 기본값 */
export const KSK1070_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'wmsCdList',
	'warehouseCdList',
];

/** KSK1030 헤더(영업출고 Info) 기본값 */
export const KSK1030_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'wmsCdList',
	'warehouseCdList',
];

/** KSK2020 헤더(생산실적 Info) 기본값 */
export const KSK2020_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'workPlaceList',
	'wmsCdList',
	'itemStatusList',
	'warehouseCdList',
];

/** KSK2020 Lot 그리드 신규 행 */
export const KSK2020_R01_LOT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

/** KSK2020 불량 그리드 신규 행 */
export const KSK2020_R01_INSPECT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

/** KSK2140 불량 그리드 신규 행 */
export const KSK2140_R01_INSPECT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE =
	'입고 가능한 창고(goodsYn=Y 또는 productYn=Y)가 등록되지 않았습니다. 창고 정보를 등록해주세요.';

export const KSK2020_R01_OUT_WAREHOUSE_MESSAGE =
	'자재출고 가능한 창고(manufactYn=Y)가 등록되지 않았습니다. 창고 정보를 등록해주세요.';

export const KSK2020_R01_BAD_WAREHOUSE_MESSAGE =
	'불량창고(badYn=Y)가 등록되지 않았습니다. 창고 정보를 등록해주세요.';

/** KSK2021 헤더(생산실적 Info) 기본값 */
export const KSK2021_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'workPlaceList',
	'wmsCdList',
	'itemStatusList',
	'warehouseCdList',
];

/** KSK2021 불량 그리드 신규 행 */
export const KSK2021_R01_INSPECT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

/** KSK2110 헤더(생산실적 Info) 기본값 */
export const KSK2110_R01_HEADER_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'compCdList',
	'workPlaceList',
	'wmsCdList',
	'itemStatusList',
	'warehouseCdList',
];

/** KSK2110 Lot 그리드 신규 행 */
export const KSK2110_R01_LOT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'itemStatusList',
];

/** KSK2110 불량 그리드 신규 행 */
export const KSK2110_R01_INSPECT_ROW_VALIDATE: CommonCodeRequirementKey[] = [
	'faultyValueList',
];

export const buildCommonCodeRequirements = (
	keys: CommonCodeRequirementKey[],
	lists: Partial<Record<CommonCodeRequirementKey, unknown[]>>,
): CommonCodeRequirement[] => keys.map((key) => ({
	key,
	message: COMMON_CODE_REQUIREMENT_CONFIG[key]?.message ?? '',
	list: lists[key] ?? [],
}));
